import { css } from "@emotion/css";

import { grey } from "@/modules/theme/utils/colors";
import { Theme } from "@/modules/theme/utils/createTheme";

export const createSearchInputStyles = ({
  spacing,
  borders,
  palette,
  typography,
}: Theme) => {
  return {
    root: css({
      width: "100%",
      display: "flex",
      flexDirection: "column",
      paddingBottom: spacing(2),
    }),
    inputWrapper: css({
      display: "flex",
      alignItems: "center",
      borderRadius: 3,
      outline: "none",
      border: "1px solid transparent",
      backgroundColor: grey[100],
      color: grey[500],

      "&:focus-within": {
        border: borders.input.main,
      },
    }),
    iconWrapper: css({
      paddingLeft: spacing(1),
    }),
    input: css({
      padding: spacing([1.5, 1]),
      border: 0,
      width: "100%",
      outline: "none",
      backgroundColor: "transparent",
      color: palette.secondary.textDark,
      fontFamily: typography.fonts.body,
      fontWeight: typography.fontWeight.semiBold,
      "::placeholder": {
        color: grey[500],
        fontWeight: 500,
      },
    }),
  };
};
